import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusOutlineIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15.6 15.6",
	style: { enableBackground: "new 0 0 15.6 15.6" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.plus-outline-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}\n	.plus-outline-icon-st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "plus-outline-icon-st0",
			d: "M7.8,14.6c3.7,0,6.8-3,6.8-6.8c0-3.7-3-6.8-6.8-6.8C4.1,1,1,4,1,7.8C1,11.5,4.1,14.6,7.8,14.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plus-outline-icon-st1",
			d: "M5,7.8h5.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plus-outline-icon-st1",
			d: "M7.8,5v5.6"
		})
	] }) }) })]
});
export default SvgPlusOutlineIcon;
